import { AnyAction, Dispatch } from 'redux';
import {
  AdapterSource,
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import { VideoConsentPayload } from './types';

export const SEND_VIDEO_CONSENT = 'SEND_VIDEO_CONSENT';
export const SEND_VIDEO_CONSENT_SUCCESS = 'SEND_VIDEO_CONSENT_SUCCESS';
export const SEND_VIDEO_CONSENT_FAIL = 'SEND_VIDEO_CONSENT_FAIL';

export const sendVideoConsent = (data: VideoConsentPayload) => (dispatch: Dispatch<AnyAction>) => {
  dispatch({
    type: SEND_VIDEO_CONSENT,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'POST',
        url: getDispatcherUrl(
          DispatcherCategoryService.UTILITY,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.VIDEO_CONSENT
        ),
        headers: {
          [DFDHeaders.mhpAdapter]: AdapterSource.MHP
        },
        data: {
          cmrn: data.cmrn,
          consentVal: data.consentVal
        }
      }
    }
  });
};
